import { memo } from 'react';
import { isEqual } from 'lodash';
import { Grid } from '@mui/material';
import {
  ComponentErrorBoundary,
  useAssistantRequest,
  EditWorkflowType,
  usePageLayoutStore,
  useEditorStore,
} from '@diana/core';
import { IComponentBuilderProps } from './ComponentBuilder.types';
import { ContainerComponentBuilder } from './ContainerComponentBuilder';
import { FieldComponentBuilder } from './FieldComponentBuilder';
import { ComponentBuilderLoader } from './ComponentBuilderLoader';
import { isSectionComponent } from '../../../Support';

export const ComponentBuilder = memo((props: IComponentBuilderProps) => {
  const { componentId, componentName, componentSize, layoutId } = props;

  const isRightDrawerOpen = usePageLayoutStore((s) => s.isRightDrawerOpen);
  const isLeftDrawerOpen = usePageLayoutStore((s) => s.isLeftDrawerOpen);

  const flowId = useEditorStore((s) => s.flow?.id);

  const storeParams = {
    type: EditWorkflowType.Component,
    flowId: flowId ?? '',
    layoutId,
    componentId,
  };

  const { hasRequest } = useAssistantRequest(storeParams);

  const isContainerComponent = isSectionComponent({ component: componentName });

  return (
    <Grid
      item
      xs={12}
      md={isRightDrawerOpen && isLeftDrawerOpen ? 12 : componentSize}
      lg={componentSize}
      sx={{ '.MuiGrid-container.MuiGrid-spacing-xs-2 > .MuiGrid-item': { pt: 1, pl: 1, pb: 0 } }}
      data-grid-layout-component-id={componentId}
    >
      <ComponentErrorBoundary>
        {hasRequest ? (
          <div data-testid="builder-component-skeleton-loader">
            <ComponentBuilderLoader componentName={componentName} />
          </div>
        ) : isContainerComponent ? (
          <ContainerComponentBuilder {...props} />
        ) : (
          <FieldComponentBuilder {...props} />
        )}
      </ComponentErrorBoundary>
    </Grid>
  );
}, isEqual);
